export default {
  //
  frogs: "Qingping Multi-Role Monitor Pro",
  frogS: "Qingping Multi-Role Monitor Pro",
  frogs_step1_h1: "Qingping Multi-Role {br}Monitor Pro",
  frogs_step1_device_description_1: "High accuracy sensors",
  frogs_step1_device_description_2: "Multiple external probes",
  frogs_step1_device_description_3: "Remote monitoring",
  frogs_step1_device_description_4: "Immediate over-limit alerts",

  frogs_step1_table_1_1: " ",
  frogs_step1_table_1_2: "Temperature",
  frogs_step1_table_1_3: "Humidity",

  frogs_step1_table_2_1: "Measurement Range",
  frogs_step1_table_2_2: "-30 ~ 60°C",
  frogs_step1_table_2_3: "0 ~ 100%RH",

  frogs_step1_table_3_1: "Typical Accuracy",
  frogs_step1_table_3_2: "±0.5°C {br}(0 ~ 50°C)",
  frogs_step1_table_3_3: "±5%RH {br}(10 ~ 90%RH)",

  frogs_step1_table_4_1: "Resolution",
  frogs_step1_table_4_2: "0.1°C",
  frogs_step1_table_4_3: "1%RH ",

  frogs_step1_look_specification: "View full specifications",

  // 222
  frogs_step2_h1: "Accurate Measurements and Reliable Connection",

  frogs_step2_1_1: "High Accuracy Temp & RH Sensor",
  frogs_step2_1_2:
    "With high accuracy and fast responding sensor from Sensirion built-in, the product provides accurate temperature and humidity readings. ",

  frogs_step2_2_1: "Supports External Probes",
  frogs_step2_2_2:
    "The probe connects to the Qingping Multi-Role Monitor Pro through the aviation plug, ensuring a stable and reliable connection.",

  //333
  frogs_step3_h1_1:
    "IP56{sup} Rated Protection -- Water {br}Splash and Dust Resistance",
  // frogs_step3_h1_2: " ",

  //444
  frogs_step4_h1: "Multiple External Probes",
  frogs_step4_h2: " View full specifications",
  frogs_step4_l_title: "Temperature Probe",
  frogs_step4_r_title: "High-Concentration CO2 Probe {br}(Flat Cable)",

  // 6666
  frogs_step6_h1: "Two Power Options",

  frogs_step6_1_1: "Two AA Batteries",
  frogs_step6_1_2:
    "The product supports lithium-Iron or alkaline batteries (1.5V), not carbon or nickel-metal hydride batteries (1.2V).",

  frogs_step6_2_1: "USB-C",
  frogs_step6_2_2:
    "The product can be powered by USB all the time, but it does not support battery charging.",

  // 8888
  frogs_step8_h1: "Long Distance Wireless Connection with Multiple Choices",
  frogs_step8_info_1: "Wi-Fi network is required.",
  frogs_step8_info_2: "LoRaWAN gateway or base station is required.",
  frogs_step8_info_3: "CMCC NB-IoT",
  frogs_step8_info_3_2: " service is required.",

  //999
  frogs_step9_h1_1: "Enhanced Signal Receiving with the External Antenna",
  frogs_step9_h1_2:
    "The product uses an SMA connector for the antenna, easy to install and maintain.",

  //10 10
  frogs_step10_h1_1: "Qingping IoT",
  frogs_step10_h1_2:
    "A platform for device management, data collection, and real-time alerting services of Qingping commercial products.",

  //11 11 11
  frogs_step11_h1_1: "No Data Loss During Network {br}Interruptions",
  frogs_step11_h1_2:
    "No need to worry about network interruptions. Up to 2,880 sets",
  frogs_step11_h1_3:
    " of data can be saved locally, and the data would be uploaded when the connection is back on.",

  //13 13 13 13
  frogs_step13_h1_1: "Two Mounting Options",
  frogs_step13_h1_2: "Mount on a DIN rail",
  frogs_step13_h1_3: "Attach to an iron surface (with the built-in magnets)",

  frogs_bottom_1:
    "The IP56 rating of Qingping Multi-Role Monitor Pro is based on tests carried out in controlled laboratory conditions under the GB/T 4208-2017 standard (using a nozzle with an inner diameter of 12.5  mm, spraying water continuously to the product for 3 minutes, at a distance of 2.5 ~ 3 meters, with a water supply intensity of 100 L/min). Qingping Multi-Role Monitor Pro cannot be soaked in water or exposed in dust for a prolonged time. Splash, and dust resistance are not permanent conditions and resistance might decrease as a result of normal wear.",
  frogs_bottom_2: "The probes require additional purchase.",
  frogs_bottom_3:
    "NB-IoT version includes a 6-year data plan of 50MB free data per year. It may vary in different batches.",
  frogs_bottom_4:
    "Data of 30 days can be saved locally while the recording interval is 15 minutes.",
  frogs_bottom_5:
    "Qingping Multi-Role Monitor Pro is compatible with 35 mm DIN rail, the DIN rail and its accessories require additional purchase.",

  // pop-up co2
  frogs_pop_co2_h1: "High-Concentration CO2 Probe (Flat Cable)",
  frogs_pop_co2_h2:
    "With multiple structural designs, the product has good protective properties and durability.",
  frogs_pop_co2_tab_1_1: "Stainless Steel Lining",
  frogs_pop_co2_tab_1_2:
    "The mesh design ensures good ventilation while preventing foreign objects from entering.",
  frogs_pop_co2_tab_2_1: "High Accuracy Sensor",
  frogs_pop_co2_tab_2_2:
    "With a Sensirion CO2 sensor built-in, the sensor has a compact size, outstanding performance and high stability.",
  frogs_pop_co2_tab_3_1: "Aluminum Alloy and Silicone Rubber Housing",
  frogs_pop_co2_tab_3_2:
    "The housing materials have excellent anti-oxidation properties, making the product suitable for high/low temperature and high humidity environments. The superior thermal conductivity of the aluminum alloy accelerates heat transfer, improving the sensor response time.",
  frogs_pop_co2_item_1: "CO2 Measurement Range",
  frogs_pop_co2_item_2: "Typical Accuracy",
  frogs_pop_co2_item_3: "Working Environment Temperature",
  frogs_pop_co2_item_4: "Working Environment Humidity",
  frogs_pop_co2_item_1_2: "0 ~ 25%",
  frogs_pop_co2_item_2_2: "±(1 vol% + 3% m.v.)",
  frogs_pop_co2_item_3_2: "-20 ~ 85°C",
  frogs_pop_co2_item_4_2: "0 ~ 95%RH (non-condensation environment)",

  // pop-up temo
  frogs_pop_temp_h1: "Temperature Probe",
  frogs_pop_temp_h2:
    "The probe can be soaked in water continuously or placed in a space without wireless network signal, such as a refrigerator.",
  frogs_pop_temp_item_1: "Temperature Range",
  frogs_pop_temp_item_2: "Typical Accuracy",
  frogs_pop_temp_item_3: "Resolution",
  frogs_pop_temp_item_4: "Material",
  frogs_pop_temp_item_5: "Ingress Protection",
  frogs_pop_temp_item_1_2: "-40 ~ 125°C",
  frogs_pop_temp_item_2_2: "±0.5°C (0 ~ 50°C)",
  frogs_pop_temp_item_3_2: "0.1°C",
  frogs_pop_temp_item_4_2: "Stainless steel probe, silicone rubber cable.",
  frogs_pop_temp_item_5_2: "IP68*: Dust resistance and can be soaked in water.",
  frogs_pop_temp_footer_text:
    "Qingping Temperature Probe is dust resistance and can be soaked in water. Their IP68 ratings are based on tests carried out in controlled laboratory conditions under the GB/T 4208-2017 standard (maximum depth of 1 meter for 60 minutes). Splash, water and dust resistance are not permanent conditions and resistance might decrease as a result of normal wear. ",

  //frogs规格-temp
  frogs_spec_long: "80 mm",
  frogs_spec_short: "33 mm",
  frogs_spec_height: "208 mm",
  frogs_size: "Size",
  frogs_color: "Color",
  frogs_spec_size: "208 × 80 × 33 mm (antenna installed)",
  frogs_temp: "Temperature",
  frogs_hum: "Humidity",
  frogs_temperature:
    "-30 ~ 60°C (powered by lithium-Iron AA batteries or USB){br}{br}-10 ~ 50°C (powered by alkaline AA batteries)",
      frogs_temperature_pc:
    "-30 ~ 60°C (powered by lithium-Iron AA batteries or USB){br}-10 ~ 50°C (powered by alkaline AA batteries)",
  frogs_humidity: "0 ~ 100%RH",

  frogs_weight: "128 g",
  frogs_screen_size: "64 × 44 mm",
  frogs_wifi: "Wi-Fi 2.4GHz or NB-IoT or LoRa",
  frogs_ble: "5.0",
  frogs_battery_support: "Batteries",
  frogs_battery_support_v: "2 lithium-Iron or alkaline AA batteries",
  frogs_USB_support: "USB power",
  frogs_package_USB: "5V⎓1A, USB-C",
  frogs_protect: "IP56",
  frogs_package_name: "Qingping Multi-Role{br}Monitor Pro",
  frogs_package_battery: "2 lithium-Iron{br}AA Batteries",

  under_ninty2:
    "Do not place this product in environment with humidity higher than 90% for long term use.",
  under_ninty3:
    "When connected to USB, the device will only be powered by USB (no the batteries). The device does not support charging the batteries.",

  frogs_device_modal: "Model",
  frogs_device_modal_v: "CGF2P-T40",
  frogs_needle_size:
    "Probe: ɸ6 × 50 mm{br}Cable: ɸ5 × 1500 mm{br}Connector: 35 mm in length",
    frogs_needle_size_m:
    "Probe: ɸ6 × 50 mm{br}{br}Cable: ɸ5 × 1500 mm{br}{br}Connector: 35 mm in length",
  frogs_needle: "Qingping{br}Temperature Probe",
  frogs_first_level: "Ingress protection{br}",
  frogs_needle_weight: "57 g",
  frogs_needle_connect: "M8 6-pin aviation plug",
  frogs_needle_protect: "IP68",

  frogs_needle_material: "Stainless steel ",
  frogs_needle_body: "Silicone rubber",
  frogs_needle_line: "Connector",
  frogs_needle_with: "PET",
  frogs_needle_package_with: "Tape{br}(for fixing the cable)",

  //frogs规格-temp
  frogs_needle_co2_tab: "High-Concentration CO2 Probe (Flat Cable)",
  frogs_needle_co2_size:
    "Probe: ɸ21 × 51 mm{br}Cable: 1.5 × 4 mm, 1500 mm in length{br}Connector: 35 mm in length",
  frogs_needle_co2_size_m:
    "Probe: ɸ21 × 51 mm{br}{br}Cable: 1.5 × 4 mm, 1500 mm in length{br}{br}Connector: 35 mm in length",

  p_co2: "CO2",
  needle_co2_temperature: "0 ~ 25%",
  frogs_needle_co2: "Qingping High-Concentration{br} CO2 Probe (Flat Cable)",
  frogs_probe_co2_modal_v: "CGF2P-HC-F",
  frogs_needle_co2_weight: "14 g",
  frogs_needle_co2_connect: "M8 6-pin aviation plug",
  frogs_first_level_co2: "Cable and connector weight",
  frogs_needle_co2_protect: "21 g",

  frogs_needle_co2_material: "Aluminum alloy, silicone rubber, stainless steel",
  frogs_needle_co2_body: "Silicone rubber",
  frogs_needle_co2_line: "Connector",
  frogs_needle_co2_line_v: "Stainless steel",
  frogs_needle_co2_with: "PET",
  frogs_needle_co2_package_with: "Tape{br}(for fixing the cable)",

  workEnvironment: "Working Environment",
  work_co2_tem: "Temperature",
  work_co2_hum: "Humidity",
  work_co2_tem_v: "-20 ~ 85°C",
  work_co2_hum_v: "0 ~ 95%RH (non-condensation environment)",

  x_co2_bottom: "1500 mm",
  x_co2_left: "35 mm",
  x_co2_right: "51 mm",
  x_co2_right_2: "40 mm",

  x_bottom: "1500 mm",
  x_left: "35 mm",
  x_right: "50 mm",

  ///
  p_probe_type: "External Probe",
  p_probe_tem: "Temp Probe",
  "p_probe_tem&hum": "Temp & RH Probe",
  "p_probe_c02&tem&hum": "CO2 & Temp & RH Probe",
  p_probe_co2: "CO2 Probe",
  p_probe_none: "None",

  //fix
  frogs_needles: "Temperature Probe",
  frogs_needle: "Qingping Temperature Probe",

  frogs_p_weight: "Probe Weight",
  frogs_sensor_body: "Cable",
  mp_multi_scene: "Outstanding in Various Scenarios",

  frogs_support_1: "Temp & RH monitoring",
  frogs_support_2: "Multiple external probes",
};
